import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getBidderEmail, isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { getBaseUrl } from '@/redux/modules/config';
import { getSubmitConsignment, submitConsignment } from '@/redux/modules/consignment';
import { openConfirmConsignmentModal } from '@/redux/modules/modal';
import { getSeller } from '@/redux/modules/seller/seller.selectors';
import { ConsignmentForm } from '@/types/Consignment';
import { sellerIdFromPath } from '@/utils/urls';

import ConsignmentsPage from './ConsignmentsPage';

type ConsignmentsPathParams = {
    sellerId?: string;
};

const ConsigmentsPageContainer = () => {
    const params = useParams<ConsignmentsPathParams>();
    const dispatch = useAppDispatch();

    const sellerId = sellerIdFromPath(params?.sellerId);

    const baseUrl = useAppSelector(getBaseUrl);
    const submitConsignmentStatus = useAppSelector(getSubmitConsignment);
    const seller = useAppSelector((state) => getSeller(state, sellerId));
    const userLoggedIn = useAppSelector(isUserLoggedIn);
    const emailAddress = useAppSelector(getBidderEmail);

    const openModal = useCallback(() => {
        dispatch(openConfirmConsignmentModal());
    }, [dispatch]);

    return (
        <ConsignmentsPage
            baseUrl={baseUrl}
            emailAddress={emailAddress}
            openConfirmConsignmentModal={openModal}
            seller={seller}
            sellerId={sellerId}
            submitConsignment={(consignmentDetails: ConsignmentForm, file: File) =>
                dispatch(submitConsignment(consignmentDetails, file))
            }
            submitConsignmentStatus={submitConsignmentStatus}
            userLoggedIn={userLoggedIn}
        />
    );
};

export default ConsigmentsPageContainer;
